import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { AppRoutes, ScrollToTop } from './router';
import FloatingWhatsApp from '@/components/feature/FloatingWhatsApp';
import MobileBottomNav from '@/components/feature/MobileBottomNav';
import './index.css';

export interface ShellAppProps {
  /** BrowserRouter basename — set to `/${locale}/website` by the shell. */
  basePath?: string;
}

const MARKETING_STYLESHEETS = [
  'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap',
  'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css',
];

function ensureStylesheets() {
  for (const href of MARKETING_STYLESHEETS) {
    if (document.querySelector(`link[href="${href}"]`)) continue;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }
}

/**
 * Entry used when the website is compiled into apps/shell.
 * Standalone Vite continues to use App.tsx + main.tsx.
 */
export default function ShellApp({ basePath = '/' }: ShellAppProps) {
  useEffect(() => {
    ensureStylesheets();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={basePath}>
        <ScrollToTop />
        <div className="pb-16 lg:pb-0">
          <AppRoutes />
        </div>
        <FloatingWhatsApp />
        <MobileBottomNav />
      </BrowserRouter>
    </I18nextProvider>
  );
}
